<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <!-- <Filter
                            :sns="false"
                            :type="false"
                            :resultType="false"
                            :resultDetailType="false"
                            :nation="false"
                            :isMonitoring="false"
                            :selectOption="state.selectOption"
                            @search="filterSearch"
                            @reset="filterSearch"
                        ></Filter> -->
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn" @click="deleteLists">선택삭제</button>
                                <!-- <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" alt="" />
                                </button> -->
                            </div>
                            <div class="count">
                                총
                                <span>{{ numberFormat(state.totalLength) }}건</span>
                            </div>
                        </div>
                        <div class="board_list">
                            <table class="board_table">
                                <colgroup>
                                    <col width="3%" />
                                    <col width="4%" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="4%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.isCheckAll" @change="toggleAll" />
                                                <span></span>
                                            </label>
                                        </th>
                                        <th>연번</th>
                                        <th>검색키워드</th>
                                        <th>검색 플랫폼</th>
                                        <th>검색일시</th>
                                        <th>구분</th>
                                        <th>진행상황</th>
                                        <th>검색결과</th>
                                        <th>삭제</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!state.isLoading">
                                    <tr v-for="(item, idx) in list.data">
                                        <td>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkList" :value="item.idx" />
                                                <span></span>
                                            </label>
                                        </td>
                                        <td>{{ item.idx }}</td>
                                        <td>
                                            <span :class="item.keyword.length > 12 ? 'more_txt' : ''" @click="moreText(item.keyword)">
                                                {{ item.keyword }}
                                            </span>
                                        </td>
                                        <td>
                                            <div class="pop_sns_box">
                                                <span v-if="item.telegram === 1"><img src="@/assets/sns/telegram.png" /></span>
                                                <span v-if="item.discord === 1"><img src="@/assets/sns/discord.png" /></span>
                                            </div>
                                        </td>
                                        <td>
                                            {{ formatDate(item.createDate) }}
                                        </td>
                                        <td>
                                            <button type="button" class="blue_btn" @click="resultBtn(item.idx)">검색결과</button>
                                        </td>
                                        <td>
                                            <template v-if="item.state === 0">대기중</template>
                                            <template v-else-if="item.state === 1">검색중</template>
                                            <template v-else-if="item.state === 2">완료</template>
                                            <template v-else-if="item.state === 3">결과 없음</template>
                                            <template v-else>에러 : {{ item.error }}</template>
                                        </td>
                                        <td>
                                            <div class="search_txt_box">
                                                <span class="total_count">
                                                    총
                                                    {{ item.cntResult ? numberFormat(item.cntResult) : 0 }}
                                                    건
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <button type="button" class="delete_btn">
                                                <img src="@/assets/board/delete_ico.png" alt="" @click="deleteList(item.idx)" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="list.data.length === 0 && !state.isLoading">
                                    <tr>
                                        <td colspan="14">
                                            <NoResult></NoResult>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="state.isLoading">
                                    <tr>
                                        <td colspan="14">
                                            <Spinner></Spinner>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <PageBtn
                            v-if="list.data.length !== 0 && !state.isLoading"
                            :currentPage="state.currentPage"
                            :totalLength="state.totalLength"
                            :perPage="state.perPage"
                            @onPaging="handlePageChange"
                        ></PageBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Popup :show="state.isModalOpen" :title="modal.title" :content="modal.content" @close="modalClose"></Popup>
</template>
<script lang="ts">
    import {
        apiService,
        globalStore,
        Header,
        Menu,
        onMounted,
        reactive,
        dateFormat,
        formatDate,
        router,
        userStore,
        numberFormat,
        NoResult,
        PageBtn,
        returnCode,
        Filter,
        Spinner,
        inject,
        watch,
    } from "@/BaseComponent";
    import Popup from "@/components/popup.vue";
    export default {
        props: [],
        components: {
            Header,
            Menu,
            Popup,
            NoResult,
            PageBtn,
            Filter,
            Spinner,
        },
        setup() {
            const global = globalStore();
            const user = userStore();
            const { changeCode } = returnCode();
            const state = reactive({
                selectOption: [{ idx: 1, text: "키워드" }] as Array<any>,

                filterData: [] as any,
                checkList: [] as number[],

                isLoading: true as boolean,
                isCheckAll: false as boolean,
                isModalOpen: false as boolean,

                perPage: 100 as number,
                totalLength: 0 as number,
                currentPage: 1 as number,
            });
            const modal = reactive({
                title: "" as string,
                content: {
                    title: "" as string,
                    main: {
                        data: "" as any,
                        class: "desc",
                        render: (data: any) => {
                            return `<p>${data}</p>`;
                        },
                    } as any,
                    subTitle: "" as string,
                    sub: {
                        data: "" as any,
                        class: "pop_sns_box",
                        render: (data: any) => {
                            return `
                                <span style="display:${data.twitter === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/telegram.png")}"></span>
                                <span style="display:${data.discord === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/discord.png")}"></span>
                            `;
                        },
                    } as any,
                    img: {
                        data: "" as any,
                        render: (data: any) => {
                            return data ? data : `<img src="${require("@/assets/common/NoImg.png")}" alt="이미지 없음" />`;
                        },
                    } as any,
                },
            });

            const list = reactive({
                data: [] as Array<any>,
            });

            onMounted(() => {
                global.setSelectMenu(5);
                getSearchList();
            });

            watch(
                () => state.checkList,
                (newVal) => {
                    state.isCheckAll = newVal.length === list.data.length;
                },
            );

            watch(
                () => global.searchDate,
                (newVal) => {
                    getSearchList();
                },
            );

            const getSearchList = async () => {
                state.isLoading = true;
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: state.filterData.searchType,
                    startDate: dateFormat(new Date(global.searchDate[0])),
                    endDate: dateFormat(new Date(global.searchDate[1])),
                    searchContent: state.filterData.searchContent,
                };
                const res = await apiService.searchRoom.getSearchList(param);
                if (res.returnCode === 0) {
                    list.data = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    alert(changeCode(res.returnCode));
                }
                state.isLoading = false;
            };

            const deleteList = async (idx: number) => {
                if (confirm("검색이력을 삭제하시겠습니까?")) {
                    const res = await apiService.searchRoom.delSearch(idx);
                    if (res.returnCode === 0) {
                        alert("삭제 완료되었습니다.");
                        getSearchList();
                    } else if (res.returnCode !== 11) {
                        return alert(changeCode(res.returnCode));
                    }
                }
            };

            const deleteLists = async () => {
                if (state.checkList.length > 0) {
                    if (confirm("선택된 검색이력을 삭제하시겠습니까?")) {
                        const param = {
                            idxList: state.checkList.join(","),
                        };
                        const res = await apiService.searchRoom.delSearchList(param);
                        if (res.returnCode === 0) {
                            alert("삭제 완료되었습니다.");
                            getSearchList();
                        } else {
                            alert(changeCode(res.returnCode));
                        }
                    }
                } else {
                    alert("삭제할 항목을 선택해주세요");
                }
            };

            const selectDate = (date: any) => {
                global.setSearchDate(date);
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getSearchList();
            };

            const resultBtn = (idx: number) => {
                router.push(`/watcherbot/result/${idx}`);
            };

            const moreText = (keyword: any) => {
                if (keyword.length > 12) {
                    modal.title = "검색키워드";
                    modal.content.title = "";
                    modal.content.main.data = keyword;
                    modal.content.subTitle = "";
                    state.isModalOpen = true;
                }
            };

            const modalClose = () => {
                modal.content.img.data = "";
                state.isModalOpen = false;
            };

            const filterSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getSearchList();
            };

            const excelDownLoad = async () => {
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: state.filterData.searchType,
                    startDate: dateFormat(new Date(state.filterData.date[0])),
                    endDate: dateFormat(new Date(state.filterData.date[1])),
                    searchContent: state.filterData.searchContent,
                    idxList: state.checkList.join(","),
                };
                const res: any = await apiService.searchRoom.downExcelSearchList(param);
                if (res.status === 200) {
                    console.log(res);

                    const blob = res.data;
                    const fileUrl = URL.createObjectURL(blob);
                    const link = document.createElement("a");

                    link.download =
                        "왓쳐봇_검색관리_" +
                        dateFormat(new Date(global.searchDate[0])) +
                        " - " +
                        dateFormat(new Date(global.searchDate[1])) +
                        ".xlsx";
                    link.href = fileUrl;
                    link.click();
                    URL.revokeObjectURL(fileUrl);
                    return alert("다운로드 완료 되었습니다.");
                } else {
                    console.error(res);
                    alert("다운로드 중 오류가 발생했습니다.");
                }
            };

            const toggleAll = () => {
                if (state.isCheckAll) {
                    state.checkList = list.data.map((item) => item.idx);
                } else {
                    state.checkList = [];
                }
            };

            return {
                global,
                user,
                state,
                modal,
                list,
                selectDate,
                handlePageChange,
                modalClose,
                numberFormat,
                resultBtn,
                moreText,
                deleteList,
                deleteLists,
                filterSearch,
                formatDate,
                excelDownLoad,
                toggleAll,
            };
        },
    };
</script>

<style scoped>
    .board_top {
        margin-top: 40px;
    }
</style>
